import React from 'react';
import Navigation from './NavigationBar';

import '../scss/index.scss';

export default function Layout({ children }) {
  return (
    <>
      <Navigation />
      <main>{children}</main>
    </>
  );
}
